(function ($) {
    "use strict";

    class VindiUpdateNotification {
        constructor() {
            this.ajaxInProgress = false;
            this.init();
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            $(document).on(
                "click",
                ".vindi-update-notice .notice-dismiss",
                this.handleDismiss.bind(this)
            );

            $(document).on(
                "click",
                ".vindi-snooze-update",
                this.handleSnooze.bind(this)
            );
        }

        handleDismiss(e) {
            if (this.ajaxInProgress) return;

            const notice = $(e.currentTarget).closest(".vindi-update-notice");
            const version = notice.data("version");

            this.ajaxInProgress = true;

            $.ajax({
                url: vindiUpdateNotifier.ajaxUrl,
                type: "POST",
                data: {
                    action: "vindi_dismiss_update_notice",
                    version: version,
                    nonce: vindiUpdateNotifier.nonce,
                },
                complete: () => {
                    this.ajaxInProgress = false;
                },
            });
        }

        handleSnooze(e) {
            e.preventDefault();

            if (this.ajaxInProgress) return;

            const button = $(e.currentTarget);
            const notice = button.closest(".vindi-update-notice");
            const originalText = button.text();

            button.prop("disabled", true).text(vindiUpdateNotifier.i18n.wait);
            this.ajaxInProgress = true;

            $.ajax({
                url: vindiUpdateNotifier.ajaxUrl,
                type: "POST",
                data: {
                    action: "vindi_snooze_update_notice",
                    nonce: vindiUpdateNotifier.nonce,
                },
                success: (response) => {
                    if (response.success) {
                        notice.fadeOut(300, function () {
                            $(this).remove();
                        });
                    } else {
                        alert(
                            response.data.message || vindiUpdateNotifier.i18n.errorSnooze
                        );
                        button.prop("disabled", false).text(originalText);
                    }
                },
                error: () => {
                    alert(vindiUpdateNotifier.i18n.errorRequest);
                    button.prop("disabled", false).text(originalText);
                },
                complete: () => {
                    this.ajaxInProgress = false;
                },
            });
        }
    }

    $(document).ready(function () {
        new VindiUpdateNotification();
    });
})(jQuery);
